import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  FormGroup,
} from "@angular/forms";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../core/authentication.service";
import * as passwordHash from "js-sha512";

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { SharedService } from "../shared/shared.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "fill", subscriptSizing: "dynamic" },
    },
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  error: string | undefined;
  showError = false;
  //loginForm: UntypedFormGroup;
  loginForm: FormGroup;
  isLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private sharedService: SharedService
  ) {
    // this.createForm();
  }

  ngOnInit() {
    let passwordregex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,15}$/;
    let emailregex: RegExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(emailregex)]],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(passwordregex),
          Validators.minLength(8),
          Validators.maxLength(15),
        ],
      ],
      remember: [true],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  ngOnDestroy() {}

  login() {
    if (this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.showError = false;
    let hashedPassword = passwordHash.sha512(this.loginForm.value.password);
    const login$ = this.authenticationService.login(
      this.loginForm.value,
      hashedPassword
    );
    login$
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
        })
      )
      .subscribe(
        (credentials: any) => {
          this.isLoading = false;
          this.router.navigate(
            [this.route.snapshot.queryParams.redirect || "/dashboard"],
            { replaceUrl: true }
          );
        },
        (error) => {
          this.isLoading = false;
          this.showError = true;
          this.error = this.sharedService.getMessages(error);
        }
      );
  }
  // private createForm() {
  //   this.loginForm = this.formBuilder.group({
  //     username: [
  //       "",
  //       [Validators.required, Validators.pattern("[^ @]*@[^ @]*")],
  //     ],
  //     password: ["", [Validators.required, Validators.minLength(8)]],
  //     remember: true,
  //   });
  // }
}
